import React from 'react'
import Layout from '../layout'
import image1 from '../multimedia/imagenes/puntopago.jpg'
import image2 from '../multimedia/imagenes/puntoexpress.png'
import image3 from '../multimedia/logo-expandido.png'
import image4 from '../multimedia/imagenes/transferencia.png'
import { Flex, Box, Card, Heading, Text, Image, Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react'
import { Link } from 'react-router-dom/cjs/react-router-dom'

class PuntoPago extends React.Component {

    render() {

        return (
            <Layout>



                <Flex flexDir={{ base: 'column', lg: 'row' }} bg={'gray.50'}>
                    <Box order={{ base: 1, lg: 1 }} className={'sideLeft3'} w={"full"} maxW={{ base: "full", lg: "50%" }} >
                        <Image src={image1} alt={'Punto de pago'} objectFit={'cover'} h={"700px"} w={"full"} />
                    </Box>
                    <Box order={{ base: 1, lg: 1 }} className={'sideRight3'} w={"full"} maxW={{ base: "full", lg: "50%" }} p={"6px"} pl={"5%"} m={"auto"}>
                        <Heading>¡Hacemos más fácil tu forma de pago!</Heading>
                        <br />
                        <Text> Puedes realizar tus pagos en los siguientes puntos</Text>
                    </Box>
                </Flex>

                <Box w="full" bg="gray.100">
                    <Flex textAlign="center" maxW="1400px" flexDir="column" p={4} m="auto" mt="3.5rem">
                        <Heading>Puntos de pago</Heading>
                        <Flex
                            alignItems="center"
                            justifyContent="space-evenly"
                            p="6"
                            minH="500px"
                            flexWrap="wrap"
                            gap="20px"
                        >
                            {/* Punto Express */}
                            <Menu>
                                <MenuButton
                                    as={Card}
                                    w="350px"
                                    h="250px"
                                    display="flex"
                                    justifyContent="center"
                                    variant="elevated"
                                    shadow="lg"
                                    p={3}
                                    className="miniCarIcon"
                                >
                                    <Image src={image2} maxH="200px" />
                                </MenuButton>
                                <MenuList>
                                    <MenuItem
                                        as="a"
                                        href="https://www.puntoxpress.com/elsalvador/adonde-pago.html"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Ver todas las agencias Punto Express
                                    </MenuItem>
                                    <MenuItem
                                        as="a"
                                        href="https://wa.me/50377380533?text=Hola,%20quiero%20información%20sobre%20mi%20pago%20en%20Punto%20Express."
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Hablar con un ejecutivo
                                    </MenuItem>
                                </MenuList>
                            </Menu>

                            {/* Transferencia bancaria y Link de pago */}
                            <Menu>
                                <MenuButton
                                    as={Card}
                                    w="350px"
                                    h="250px"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    variant="elevated"
                                    shadow="lg"
                                    p={3}
                                    className="miniCarIcon"
                                >
                                    <Image src={image4} h="200px" maxW="250px" />
                                </MenuButton>
                                <MenuList>
                                    <MenuItem
                                        as="a"
                                        href="https://wa.me/50377380533?text=Hola,%20me%20gustaría%20pagar%20mi%20vehículo%20mediante%20transferencia."
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Transferencia bancaria
                                    </MenuItem>
                                    <MenuItem
                                        as="a"
                                        href="https://wa.me/50377380533?text=Hola,%20me%20gustaría%20realizar%20mi%20pago%20mediante%20link%20de%20pago."
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Link de pago
                                    </MenuItem>
                                </MenuList>
                            </Menu>

                            {/* Agencias físicas */}
                            <Link to="agencias">
                                <Card
                                    w="350px"
                                    h="250px"
                                    display="flex"
                                    justifyContent="center"
                                    variant="elevated"
                                    shadow="lg"
                                    p={4}
                                    className="miniCarIcon"
                                >
                                    <Image src={image3} width="full" h="auto" />
                                </Card>
                            </Link>
                        </Flex>
                    </Flex>
                </Box>


            </Layout>
        )
    }

}

export default PuntoPago